import { createContext, useContext } from "react";

export const BackendAvailabilityContext = createContext(false);

export function useBackendAvailability() {
  return useContext(BackendAvailabilityContext);
}
